import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import About from './sections/About';
import FAQ from './sections/FAQ';
import Help from './sections/Help';
import Contact from './sections/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';


// import QRScanner from './components/QRScanner';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Header />
      <main>
        <Routes>
          {/* Home route with all sections */}
          <Route
            path="/"
            element={
              <>
                <section id="hero"><Hero /></section>
                <section id="about"><About /></section>
                <section id="faq"><FAQ /></section>
                <section id="help"><Help /></section>
                <section id="contact"><Contact /></section>
              </>
            }
          />

          {/* Individual pages */}
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          
       
        </Routes>
      </main>
      {/* <QRScanner /> */}
      <Footer />
    </Router>
  );
}

export default App;
